import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-client-admins.loaders';
import { converters } from './admin-client-admins.converters';
import { ClientAdminsFilters } from './admin-client-admins.types';

export const clientAdminsKeys = queryKeyFactory('admin-client-admins');

export const useClientAdmins = (
  clientId: string,
  filters: Partial<ClientAdminsFilters> = {},
) => {
  return useQuery({
    queryKey: clientAdminsKeys.list(clientId, filters),
    queryFn: () => loaders.getAdmins({ clientId, filters }),
    select: converters.getAdmins,
    enabled: !!clientId,
  });
};

export const useClientAdmin = (clientId: string, adminId: string) => {
  return useQuery({
    queryKey: clientAdminsKeys.list(clientId, adminId),
    queryFn: () => loaders.getAdmin({ clientId, adminId }),
    select: converters.getAdmin,
    enabled: !!clientId && !!adminId,
  });
};
